// Pemendek nama berkas untuk ditampilkan. Beda dari `truncate` CSS: potongannya di TENGAH supaya
// ekstensi tetap terbaca — "pngtree-special-promo-banner-for-sale.png" jadi "pngtree-special-pro….png".
// Bagi pengunggah, ".png / .pdf" itulah yang menjawab "berkasku yang mana", dan justru itu yang
// pertama hilang kalau dipotong dari belakang.
const ELLIPSIS = "…";

export function truncateFileName(name, max = 28) {
    const full = String(name ?? "").trim();
    if (full.length <= max) return full;

    // Titik di posisi 0 = berkas tersembunyi (".gitignore"), bukan pemisah ekstensi.
    const dot = full.lastIndexOf(".");
    const ext = dot > 0 && full.length - dot <= 6 ? full.slice(dot) : "";

    // Ekstensi sendiri sudah menghabiskan jatah -> tak ada yang bisa diselamatkan, potong lurus.
    const head = max - ext.length - ELLIPSIS.length;
    if (head < 1) return `${full.slice(0, Math.max(1, max - ELLIPSIS.length))}${ELLIPSIS}`;

    return `${full.slice(0, head)}${ELLIPSIS}${ext}`;
}
